import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-purple-700">Terms and Conditions</h1>

      <p className="mb-4">Effective Date: August 2, 2025</p>

      <p className="mb-4">
        By accessing and using our free background remover and text-behind-image tools, you agree to the following terms:
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Free Use of Tools</h2>
      <p className="mb-4">
        Our services are provided completely free of charge. You may use them for personal or commercial projects.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. No Account Required</h2>
      <p className="mb-4">
        You do not need to register or create an account to access or use our tools.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Intellectual Property</h2>
      <p className="mb-4">
        All design tools, interfaces, and website content are the intellectual property of our team. You retain ownership of your uploaded images and any resulting outputs.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Prohibited Uses</h2>
      <p className="mb-4">
        You agree not to use our tools to generate or distribute content that is unlawful, harmful, abusive, defamatory, or otherwise inappropriate.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. No Warranty</h2>
      <p className="mb-4">
        Our services are provided "as is" without warranties of any kind. We do not guarantee error-free performance or availability at all times.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Limitation of Liability</h2>
      <p className="mb-4">
        We are not liable for any damages or losses resulting from your use or inability to use our tools.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Changes to Terms</h2>
      <p className="mb-4">
        We may update these Terms and Conditions at any time. Continued use of the service implies acceptance of any revised terms.
      </p>

      <p className="mt-6">For questions regarding these terms, please reach out through our website's contact page.</p>
    </div>
  );
};

export default TermsAndConditions;